import * as React from "react";
import { Switch } from "antd";
import CreateForm from "widget/formInfo/createForm";
// 小工具栏
import SmallTools from "widget/smallTools";
// 弹窗增强
import ModalEnhance from "widget/modalEnhance";
// 筛选项管理组件
import ScreeningItem from "containers/ScreeningItem";
// 表单查询部分的模型
import Model from "viewModel";
// 表格组件
import TableEnhance from "../widget/tableEnhance";
// tab组件
import TabEnhance from "../widget/tabEnhance";
// 功能按钮群组
import OrderListButtonGroup from "containers/OrderListButtonGroup";

// 覆盖列表字段
import overrideColoumns from "widget/orderListColFragment/tableColFragment";

// 过滤表单的字段
import { filterParams } from "utils/tool";

// 生成唯一的可识别id
import cuid from "cuid";

// 用于测试订单列表的接口响应时间 主要是对比 content-download 的时间
//import AxioTest from "components/AxioTest";

// import MultiSelect from "widget/multiSelect2";

import { PositionProperty, FlexDirectionProperty } from "csstype";

//import TagEnhance from "widget/tagEnhance";

// import { EMail } from "utils/enum/orderListFormEnum";

import {
  ETabType,
  OrderListTabInfo,
  EHistoryType
} from "utils/enum/orderListEnum";

import { EOrderListPageType } from "utils/enum/orderListFormEnum";

import "styles/orderList.scss";
import "styles/orderListColFragment.scss";

// 获取地址栏参数
import { getSearchVal } from "utils/tool";

class OrderList extends React.Component<any, any> {
  // 表格可识别id
  tableEnhanceCuid = cuid();
  // 表单唯一标识
  createFormCuid = cuid();
  search = this.props.location.search;
  orderstatus = getSearchVal(this.search, "orderstatus") as any * 1;
  account = getSearchVal(this.search, "account");
  saler = getSearchVal(this.search, "saler");

  constructor(props: any) {
    super(props);
    let pageType =
      this.props.match.params.type || EOrderListPageType.zidingdanliebiao;

    this.state = {
      // 是否刷新页面
      isRefresh: false,
      pageType: pageType,
      loading: false,
      // createForm实例对象
      createFormRef: null,
      // 历史订单
      isHistory: EHistoryType.No,
      // 筛选项弹窗显示状态
      screeningVisible: false,
      // 筛选项ref对象
      screeningItemRef: null,
      // 筛选项列表
      screeningItemList: [],
      // 表单中可能会需要隐藏的字段
      hiddenField: [this.getHiddenField(pageType)],
      // 分页参数
      paging: new Model.PagingModel(),
      listStartIndex: 1,
      // 当前选中的tab项 对应OrderListEnum ETabType 枚举值, 默认值为全部订单
      tabType: this.orderstatus || ETabType.All,
      tabs: this.getTabForPageType(pageType),
      // 快捷查询
      isQuickSearch: false,
      // 列字段集合
      columns: overrideColoumns(
        Model.OrderModel.getColumn(),
        "." + this.tableEnhanceCuid,
        this
      ),
      // 当前选中的订单编号
      orderNos: [],
      // 获取form查询项
      formData: this.props.getFormData(
        this.submit,
        this.onReset,
        this.onEditField,
        pageType,
        this.search
      ),
      tabTimestamp: new Date()
    };
  }


  // 组件完成加载后触发的事件
  componentDidMount() {
    // 获取筛选项数据
    this.props.getItemsList();

    // 获取订单列表
    this.getOrderList(1, { rows: 20, account: this.account, headId: this.saler }, this.orderstatus || ETabType.All, this.state.isHistory);
    // 动态计算表格高度
    this.calcScroll(this.state.columns, true);
    // setTimeout(() => {
    //   this.calcScroll(this.state.columns);
    // }, 500);
  }

  shouldComponentUpdate(nextProps: any, nextState: any, nextContext: any) {
    // 查询模式
    if (this.props.orderRequestMode != nextProps.orderRequestMode) {
      this.setState({
        isHistory: nextProps.orderRequestMode
      });
    }

    this.updateSysChecked(nextState);

    this.updateDocumentTitle(nextState);

    this.updateDataForTab(nextState, nextProps);

    if (nextState.isRefresh) {
      this.clearAllState(nextProps, nextState);
      return false;
    }
    const registerResult = this.registerHotkeyHandle();
    const quickResult = this.quickSearch(nextProps, nextState);
    return registerResult && quickResult;
  }

  // 组件初始化时不调用，只有在组件将要更新时才调用，此时可以修改state
  componentDidUpdate(prevProps, prevState) {
    // 判断是否需要刷新列表
    if (prevState.isRefreshScroll) {
      this.setState({
        isRefreshScroll: false
      });
      this.calcScroll(prevState.columns);
    }
  }

  static getDerivedStateFromProps(nextProps: any, prevState: any) {
    const intercept = OrderList.intercept(nextProps, prevState);
    const data = nextProps.screeningItem;

    // 只有在筛选项列表数量为0时才执行以下代码;
    if (prevState.screeningItemList.length === 0 && data) {
      let fieldList: any = [];
      for (const item in data) {
        // 保存需要隐藏的字段
        if (data[item] == 0) {
          fieldList.push(Model.TestModel.mapToField(item));
        }
      }
      return {
        ...intercept,
        screeningItemList: fieldList
      };
    } else {
      return {
        ...intercept
      };
    }
  }

  // 拦截 判断页面类型 pageTpye 参数是否与之前状态的值保持一致
  static intercept = (nextProps: any, prevState: any) => {
    const params = nextProps.match.params;
    if (JSON.stringify(params) !== "{}") {
      if (params.type == prevState.pageType) {
        return {};
      } else {
        return {
          isRefresh: true,
          pageType: params.type
        };
      }
    }
    return {};
  };

  // 把常用的值保存到autocomplete中
  saveToAutoComplete = () => {
    // 行程公司
    //const saveField = ["travelCompany"];

    this.props.saveAutoComplete({
      name: "formDemo1",
      settInfo: {
        travelCompany: [this.props.CreateForm["travelCompany"]]
      }
    });
  };

  // 提交表单
  submit = () => {
    //debugger;
    // 这里需要保存autocomplete的值
    this.saveToAutoComplete();
    this.onSearch();
  };

  // 获取CreateForm 的实例对象
  getCreateFormRef = e => {
    let _this = this
    this.setState({
      createFormRef: e
    }, () => {
      const indexNum = _this.props.location.search.indexOf('account')
      if (indexNum > -1) {
        _this.state.createFormRef.createFormSetValue("account", decodeURI(_this.props.location.search.split('=')[1]));
      }
    });
  };

  // getDefaultSaler(salerId) {
  //   const { salers } = this.props
  //   if (salers) {
  //     return salers.filter((saler: any) => {
  //       return saler.id === salerId
  //     })[0].name
  //   }
  // }

  // 初始化数据
  initData = () => {
    const { setValue } = this.props

    if (this.search) {
      setValue({
        formInfo: {
          account: this.account
        },
        model: "formDemo1",
        field: "account",
        value: this.account
      });
      setValue({
        formInfo: {
          headId: this.saler
        },
        model: "formDemo1",
        field: "headId",
        value: this.saler as any * 1
      });
      return { account: this.account, user: this.saler };
    }
    return null;
  };


  // 获取表单中需要隐藏的字段
  getHiddenField = type => {
    // 需要隐藏的订单来源字段名称
    let field = "";
    switch (Number(type)) {
      case EOrderListPageType.tianmaohaiwaidian:
      case EOrderListPageType.fengongsitianmaodian:
      case EOrderListPageType.tianmaolijiangdian:
        field = "fromSource";
        break;
      case EOrderListPageType.zidingdanliebiao:
      default:
        break;
    }
    return field;
  };

  // 获取Tab栏
  getTabForPageType = pageType => {
    let field: any = [],
      newOrderListTabInfo: any = [];

    const common = (newOrderListTabInfo, item, num) => {
      newOrderListTabInfo.push({
        ...item,
        name: (
          <span>
            {item.name}{" "}
            {/* <span style={{ color: "red", fontWeight: "bold" }}> */}
            <span>({num || 0})</span>
          </span>
        )
      });
    };

    for (const item of OrderListTabInfo) {
      switch (item.value) {
        case ETabType.Omit:
          common(newOrderListTabInfo, item, this.props.statisticsInfoTab.yiLou);
          break;
        case ETabType.Audit:
          common(
            newOrderListTabInfo,
            item,
            this.props.statisticsInfoTab.daiShenHe
          );
          break;
        case ETabType.Full:
          common(
            newOrderListTabInfo,
            item,
            this.props.statisticsInfoTab.manYuan
          );
          break;
        case ETabType.Abnormal:
          common(
            newOrderListTabInfo,
            item,
            this.props.statisticsInfoTab.yiChang
          );
          break;
        case ETabType.Occupied:
          common(
            newOrderListTabInfo,
            item,
            this.props.statisticsInfoTab.zhanWei
          );
          break;
        default:
          newOrderListTabInfo.push(item);
          break;
      }
    }

    switch (Number(pageType)) {
      case EOrderListPageType.shangcheng:
        const showTabs = [
          ETabType.All,
          ETabType.Unfinished,
          ETabType.Omit,
          ETabType.Audit,
          ETabType.Full,
          ETabType.UnsubscribeFailure,
          ETabType.Abnormal,
          ETabType.Occupied
        ];

        field = newOrderListTabInfo.filter((item, index) => {
          return showTabs.indexOf(item.value) != -1;
        });
        break;
      case EOrderListPageType.tianmaohaiwaidian:
      case EOrderListPageType.fengongsitianmaodian:
      case EOrderListPageType.tianmaolijiangdian:
      case EOrderListPageType.zidingdanliebiao:
      default:
        field = newOrderListTabInfo;
        break;
    }
    return field;
  };

  // 清除状态，使页面恢复为初始状态
  clearAllState = (nextProps: any, nextState: any) => {
    const paging = new Model.PagingModel();
    paging.rows = nextState.paging.rows;
    const pageType = nextProps.match.params.type;
    // 重置状态
    this.setState(
      {
        isHistory: EHistoryType.No,
        screeningVisible: false,
        paging: paging,
        tabType: ETabType.All,
        tabs: this.getTabForPageType(pageType),
        isRefresh: false,
        formData: this.props.getFormData(
          this.submit,
          this.onReset,
          this.onEditField,
          pageType,
          this.search
        ),
        hiddenField: [this.getHiddenField(pageType)]
      },
      () => {
        // 根据地址栏参数查询
        const searchForm = this.initData();
        if (!searchForm) {
          // 重置表单数据
          this.resetForm();
        }

        // 更新订单列表数据
        this.getOrderList(
          paging,
          searchForm,
          // this.props.CreateForm,
          ETabType.All,
          EHistoryType.No
        );
      }
    );
  };



  // 编辑筛选项
  onEditField = e => {
    this.setState({
      screeningVisible: true
    });
  };

  // 重置表单数据
  onReset = e => {
    this.onResetSearch();
  };

  // 重置表单数据
  resetForm = () => {
    this.props.resetModel({
      modelName: "formDemo1",
      model: "TestModel"
    });
  };

  // 获取默认查询参数  不同的子订单页面 参数不同
  getDefaultParam = formParam => {
    switch (Number(this.state.pageType)) {
      case EOrderListPageType.tianmaolijiangdian:
        return { fromSource: EOrderListPageType.tianmaolijiangdian };
      case EOrderListPageType.tianmaohaiwaidian:
        return { fromSource: EOrderListPageType.tianmaohaiwaidian };
      case EOrderListPageType.fengongsitianmaodian:
        return { fromSource: EOrderListPageType.fengongsitianmaodian };
      // 商城
      case EOrderListPageType.shangcheng:
        if (formParam && formParam.fromSource) {
          return {};
        } else {
          return { fromSource: EOrderListPageType.shangcheng };
        }
      // 子订单列表
      case EOrderListPageType.zidingdanliebiao:
      default:
        return {};
    }
  };

  // 清空列表中复选框
  clearListChecked = () => {
    // 清空列表中的选中项
    this.setState({
      orderNos: []
    });
  };

  // 获取订单列表数据
  getOrderList = (
    pagingParam,
    createFormParam,
    tabType = ETabType.All,
    isHistory = EHistoryType.No
  ) => {
    // this.props.updateLoading({
    //   spinning: true,
    //   tip: "数据加载中。。。"
    // });

    this.setState({
      loading: true
    });

    // 清除列表选中状态
    this.clearListChecked();

    let formParam: any = {
      ...createFormParam,
      ...pagingParam,
      ...this.getDefaultParam(this.props.CreateForm),
      type: tabType,
      queryHistory: isHistory
    };
    // 获取订单列表
    this.props.getOrderList({
      ...formParam,
      // 允许接口完成调用后，执行组件中的方法
      callback: () => {
        this.setState({
          loading: false
        });

        // this.props.updateLoading({
        //   spinning: false
        // });
        // 更新列表时间戳
        // this.setState({
        //   tableTimestamp: new Date().getTime()
        // });
      }
    });

    // 获取tab栏的统计数据
    this.props.getOrderListSum({
      ...formParam,
      queryNum: 2,
      callback: () => {
        this.setState({
          tabs: this.getTabForPageType(this.state.pageType)
        });
      }
    });
    // 获取按钮组旁边的统计数据
    this.props.getOrderListSum({
      ...formParam,
      queryNum: 1
    });
  };

  // 获取导出需要的查询参数
  getFormParamForExport = () => {
    return {
      ...this.props.CreateForm,
      ...this.getDefaultParam(this.props.CreateForm),
      type: this.state.tabType,
      queryHistory: this.state.isHistory
    };
  };

  // 查询事件
  onSearch = (e = null) => {
    const paging = new Model.PagingModel();
    paging.page = 1;
    paging.rows = this.state.paging.rows;
    this.setState({
      paging: paging,
      listStartIndex: 1
    });
    this.getOrderList(
      paging,
      this.props.CreateForm,
      this.state.tabType,
      this.state.isHistory
    );
  };

  // 重置刷新
  onResetSearch = () => {
    const paging = new Model.PagingModel();
    paging.page = 1;
    paging.rows = this.state.paging.rows;
    this.setState({
      ...this.state.paging,
      listStartIndex: 1
    });
    this.getOrderList(paging, {}, this.state.tabType, this.state.isHistory);
  };

  // 重刷 按照当前页面的条件查询数据
  refresh = (e = null) => {
    const paging = new Model.PagingModel();
    paging.page = this.state.paging.page;
    paging.rows = this.state.paging.rows;
    // this.setState({
    //   ...this.state.paging,
    //   listStartIndex: 1
    // });
    this.getOrderList(
      paging,
      this.props.CreateForm,
      this.state.tabType,
      this.state.isHistory
    );
  };

  // 快捷查询
  onQuickSearch = (nextProps, nextState) => {
    const paging = new Model.PagingModel();
    paging.page = 1;
    paging.rows = this.state.paging.rows;
    this.setState({
      ...this.state.paging,
      listStartIndex: 1
    });
    this.getOrderList(
      paging,
      nextProps.CreateForm,
      this.state.tabType,
      this.state.isHistory
    );
  };

  // 改变每页显示条目数
  onShowSizeChange = (current, pageSize) => {
    const paging = new Model.PagingModel();
    paging.page = current;
    paging.rows = pageSize;
    this.setState({
      // ...this.state.paging,
      paging: paging
    });
    this.getOrderList(
      paging,
      this.props.CreateForm,
      this.state.tabType,
      this.state.isHistory
    );
  };

  // 跳转到某页
  onChange = pageNumber => {
    // console.log("pageNumber", pageNumber);
    // console.log("我更新了");
    const paging = new Model.PagingModel();
    paging.page = pageNumber;
    paging.rows = this.state.paging.rows;
    this.setState({
      paging: paging,
      listStartIndex: pageNumber
    });
    this.getOrderList(
      paging,
      this.props.CreateForm,
      this.state.tabType,
      this.state.isHistory
    );
  };

  // 分部组件样式
  tabSlot = {
    position: "absolute" as PositionProperty,
    right: 0,
    zIndex: 10,
    display: "flex",
    flexDirection: "row" as FlexDirectionProperty,
    alignItems: "center",
    height: 40
  };

  // 切换历史订单开关
  onSwitchChange = checked => {
    this.setState({
      isHistory: checked ? EHistoryType.Yes : EHistoryType.No,
      tabTimestamp: new Date()
    });
  };

  // 历史订单占位组件（分部组件）
  getSlot = () => {
    let otherSlot: any = [];
    switch (Number(this.state.pageType)) {
      case EOrderListPageType.shangcheng:
        otherSlot.push(
          <a href="###" style={{ marginRight: 20 }}>
            未付款订单
          </a>
        );
        break;
      default:
        break;
    }
    const isChecked = this.state.isHistory ? true : false;
    return (
      <div style={this.tabSlot}>
        {otherSlot}
        <span>历史订单：</span>
        <Switch
          checkedChildren="开"
          unCheckedChildren="关"
          checked={isChecked}
          onChange={this.onSwitchChange}
        />
      </div>
    );
  };

  // tab 切换回调 activeKey 对应 OrderListEnum 枚举值
  tabClickCallBack = activeKey => {
    // //setTimeout(() => {
    // // 在这里需要刷新列表中的数据并且更新列表中的列
    // const columns = overrideColoumns(Model.OrderModel.getColumn(activeKey));
    // // 更新列表数据
    // const paging = new Model.PagingModel();
    // paging.rows = this.state.paging.rows;

    // this.getOrderList(paging, activeKey, this.state.isHistory);

    // 更新列表项, tab选中项,分页参数
    this.setState({
      tabType: activeKey,
      listStartIndex: 1
    });

    this.props.updateTabStatus(activeKey);

    // this.calcScroll(columns);

    // this.setState({
    //   columns,
    //   ...this.state.paging
    //});
    //}, 5000);
  };

  // 计算滚动条参数 计算横向滚动条的长度
  calcScroll = (columns, isDefault = false) => {
    const scroll = { x: 0, y: 0 };
    for (const item of columns) {
      scroll.x += item.width || 100;
    }
    scroll.y = 0;
    const tableDom = document.querySelector("." + this.tableEnhanceCuid);
    const orderListDom = document.querySelector(".formDemo1");
    const createFormDom = document.querySelector(
      "[data-cuid='" + this.createFormCuid + "']"
    );

    // 计算table高度 减去createForm高度 和 其它固定组件的高度
    if (tableDom && orderListDom && createFormDom) {
      const tableWidth = Number(tableDom["offsetWidth"]);
      // const orderListHeight = Number(orderListDom["offsetHeight"]);
      // const createFormHeight = Number(createFormDom["offsetHeight"]);
      if (tableWidth > scroll.x) {
        scroll.x = 0;
      }
      // if (isDefault) scroll.y = orderListHeight - 30 - 240;
      // else scroll.y = orderListHeight - createFormHeight - 240;
    }

    //tableDom.offsetWidth();

    // ;
    this.setState({
      scroll: scroll
    });
  };

  // 获取表格中选中的id值
  getTableCheckedKeys = keys => {
    this.props.updateListTimestamp();
    this.setState({
      orderNos: keys
    });
  };

  // 获取表格的ref实例对象
  getTableRef = ref => {
    this.setState({
      tableRef: ref
    });
  };

  // 按钮组操作完成后延迟1.5秒执行刷新
  buttonGroupAfterSearch = () => {
    //this.refresh();
    setTimeout(() => {
      this.refresh();
    }, 2000);
  };


  // 覆盖工具栏默认样式
  overwriteDefaultStyle = () => {
    return {
      toolsStyle: {
        right: 20
      }
    };
  };

  // 覆盖扩大缩小默认提示语句
  getEnlargeProps = () => {
    return {
      enlargePlaceholder: "扩大该页面",
      shrinkPlaecholder: "缩小该页面"
    };
  };

  // 根据tab状态更新数据
  updateDataForTab = (nextState, nextProps) => {
    // if (nextState.tabType == this.state.tabType) {
    if (nextProps.tabStatus == this.props.tabStatus) {
      this.updateScroll(nextProps, nextState);
      return;
    } else {
      // tab栏状态改变时才刷新数据
      const activeKey = nextProps.tabStatus;
      let columns;
      if (activeKey == 13) {
        columns = overrideColoumns(
          Model.OrderModel.getShortColumn(activeKey),
          "." + this.tableEnhanceCuid,
          this
        );
      } else {
        columns = overrideColoumns(
          Model.OrderModel.getColumn(activeKey),
          "." + this.tableEnhanceCuid,
          this
        );
      }
      // 更新列表数据
      const paging = new Model.PagingModel();
      paging.rows = nextState.paging.rows;
      this.getOrderList(
        paging,
        nextProps.CreateForm,
        activeKey,
        nextState.isHistory
      );

      setTimeout(() => {
        this.calcScroll(columns);
      }, 2000);

      this.setState({
        columns,
        formData: this.props.getFormData(
          this.submit,
          this.onReset,
          this.onEditField,
          activeKey,
          this.search
        ),
        ...nextState.paging
      });
    }
  };

  //this.calcScroll(this.state.columns);
  // 更新列表的高度
  updateScroll(nextProps, nextState) {
    // console.log("updateScroll");
    if (nextProps.screeningItem && this.props.screeningItem) {
      const newCount = Object.keys(nextProps.screeningItem).filter(item => {
        return nextProps.screeningItem[item] == "1";
      }).length,
        oldCount = Object.keys(this.props.screeningItem).filter(item => {
          return this.props.screeningItem[item] == "1";
        }).length;

      if (newCount != oldCount) {
        this.setState({
          isRefreshScroll: true
        });
        // setTimeout(() => {
        //   this.calcScroll(nextState.columns);
        // }, 100);
      }
    }
  }

  // 更新页面title
  updateDocumentTitle = nextState => {
    const pageType = nextState.pageType;
    let title = "子订单列表 - 懒猫旅行后台管理";
    switch (pageType) {
      case "3":
        title = "天猫海外店 - 懒猫旅行后台管理";
        break;
      case "4":
        title = "天猫丽江店 - 懒猫旅行后台管理";
        break;
      case "13":
        title = "分公司天猫店 - 懒猫旅行后台管理";
        break;
      default:
        title = "子订单列表 - 懒猫旅行后台管理";
        break;
    }
    document.title = title;
  };

  // 更新菜单选中状态
  updateSysChecked = nextState => {
    let mkey, openKey;
    const pageType = nextState.pageType;

    switch (pageType) {
      case "3":
        mkey = "999_3";
        openKey = "999";
        break;
      case "4":
        mkey = "999_5";
        openKey = "999";
        break;
      case "13":
        mkey = "999_4";
        openKey = "999";
        break;
      default:
        mkey = "999_1";
        openKey = "999";
        break;
    }

    this.props.updateSysMenuStatus({
      selectedKeys: mkey,
      openKeys: [openKey]
    });
  };


  // 注册快捷键
  registerHotkeyHandle = () => {
    // 这里是使用快捷键查询，需要保持autocomplete值
    if (this.props.hotkey["enter"].activity) {
      this.saveToAutoComplete();
      this.onSearch(null);
      this.props.updateHotKey({
        hotkey: "enter",
        activity: false
      });
      return false;
    } else if (this.props.hotkey["delete"].activity) {
      // 重置表单的数据
      this.resetForm();
      // 已重置后的参数进行查询
      this.onResetSearch();
      this.props.updateHotKey({
        hotkey: "delete",
        activity: false
      });
      return false;
    }
    return true;
  };

  // 快捷查询（点击列表中的链接进行查询）
  quickSearch = (nextProps, nextState) => {
    if (nextState.isQuickSearch === true) {
      this.onQuickSearch(nextProps, nextState);
      this.setState({
        isQuickSearch: false
      });
    }
    return true;
  };

  // 关闭筛选项弹窗
  closeScreeningItem = () => {
    this.setState({
      screeningVisible: false
    });
  };

  // 筛选项提交更改
  screeningItemSubmit = () => {
    const updateFiledList = _this => {
      // 筛选项数据变化时需要手动调用下面的方法才能更新更新筛选项
      // 只有screeningItemList变化了才能使CreateForm Render 最新的数据
      _this.props.getItemsList({
        callback: () => {
          const data = _this.props.screeningItem;
          let fieldList: any = [];
          for (const item in data) {
            // 保存需要隐藏的字段
            if (data[item] == 0) {
              fieldList.push(Model.TestModel.mapToField(item));
            }
          }
          // 重置指定字段的值
          this.props.resetFieldsValue({
            modelName: "formDemo1",
            model: "TestModel",
            fields: fieldList
          });
          _this.setState(
            {
              screeningItemList: fieldList
            },
            () => {
              // this.calcScroll(this.state.columns);
              // 筛选项提交后 查询列表
              this.onSearch();
            }
          );
        }
      });
    };

    async function screeningItemSubmit(_this) {
      const result = await _this.state.screeningItemRef["submit"](() => {
        updateFiledList(_this);
      });
      if (result) {
        _this.setState({
          screeningVisible: false
        });
      }
    }
    screeningItemSubmit(this);
  };

  // 获取筛选项ref对象;
  getScreeningItemRef = ref => {
    this.setState({
      screeningItemRef: ref
    });
  };

  // 初始化组件
  initComponents = () => {
    const hiddenField = [
      ...this.state.screeningItemList,
      ...this.state.hiddenField
    ];

    let orderTotal: any = this.props.orderTotal;
    // 只有tab栏为全部订单时才对分页进行处理
    if (ETabType.All == this.state.tabType) {
      // 计算需要展示的分页
      // 带条件时分页总数按服务端返回的来暂时
      let param: any = filterParams(this.getFormParamForExport());
      delete param.queryHistory;
      delete param.type;

      // 没有查询参数
      if (Object.keys(param || {}).length === 0) {
        orderTotal =
          this.props.orderTotal > 10000 ? 10000 : this.props.orderTotal;
      } else {
        orderTotal = this.props.orderTotal;
      }
    }

    return (
      <React.Fragment>
        <CreateForm
          name="666"
          onRef={this.getCreateFormRef}
          FormData={this.state.formData}
          CreateForm={this.props.CreateForm}
          // rematch  share state
          ModelName="formDemo1"
          Model="TestModel"
          componentName="formDemo1CreateForm"
          fieldList={hiddenField}
          cuid={this.createFormCuid}
          containerBody={".formDemo1"}
        />
        {/* tab功能块 */}
        <TabEnhance
          tabPanes={this.state.tabs}
          slot={this.state.tabType != 13 ? this.getSlot() : ''}
          tabClickCallBack={this.tabClickCallBack}
          timestamp={this.state.tabTimestamp}
        >
          {/* <Spin spinning={!this.props.statisLoaded} /> */}
        </TabEnhance>
        {/* 按钮组 */}
        {
          this.state.tabType != 13 && <OrderListButtonGroup
            pageType={this.state.pageType}
            orderNo={this.state.orderNos}
            formParam={this.getFormParamForExport()}
            orderTotal={this.props.orderTotal}
            onSearch={this.buttonGroupAfterSearch}
          />
        }
        <TableEnhance
          timestamp={this.props.tableTimestamp}
          selectedRowKeys={this.state.orderNos}
          style={{ marginTop: 18 }}
          loading={this.state.loading}
          className={this.tableEnhanceCuid}
          columns={this.state.columns}
          data={this.props.orderInfo.orderList}
          model="TestModel"
          modelName="formDemo1"
          onSearch={this.onSearch}
          pageIndex={this.state.listStartIndex}
          isHideRowSelection={this.state.tabType == 13}
          expType={this.state.tabType == 13}
          total={orderTotal}
          componentName="formDemo1TableEnhance"
          // 分页相关
          onShowSizeChange={this.onShowSizeChange}
          // 分页相关
          onChange={this.onChange}
          scroll={this.state.scroll}
          returnCheckedKey={this.getTableCheckedKeys}
          onRef={this.getTableRef}
        />
      </React.Fragment>
    );
  };


  render() {
    return (
      <div className="formDemo1">
        <SmallTools
          content={this.initComponents()}
          isOpenEnlarge={false}
          isOpenFieldDrawer={false}
        // enlargeProps={this.getEnlargeProps()}
        // overwriteDefaultStyle={this.overwriteDefaultStyle()}
        />
        {/* <AxioTest /> */}
        <ModalEnhance
          title="编辑搜索字段"
          visible={this.state.screeningVisible}
          childComponent={<ScreeningItem onRef={this.getScreeningItemRef} />}
          close={this.closeScreeningItem}
          ok={this.screeningItemSubmit}
        />
      </div>
    );
  }
}

export default OrderList;
